module.exports = __webpack_public_path__ + "20250721160708/img/xzzh.ce2f9b23.png";